/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/491/interface/api/cat_1890
 */

import { message } from 'ant-design-vue'
import {
  config_add_config_flow_day_post,
  config_add_config_permissions_post,
  config_add_config_product_price_post,
  config_add_config_product_size_post,
  config_add_config_staff_match_post,
  config_add_process_post,
  config_add_process_node_post,
  config_add_process_node_relation_post,
  config_add_process_node_state_post,
  config_add_supplier_cycle_post,
  config_del_config_flow_day_post,
  config_del_config_permissions_post,
  config_del_config_product_price_post,
  config_del_config_staff_match_post,
  config_del_supplier_cycle_get,
  config_delete_process_node_post,
  config_delete_process_node_relation_post,
  config_delete_process_node_state_post,
  config_get_cp_by_skc_post,
  config_importSupplierInfo_post,
  config_init_cp_skc_post,
  config_list_category_size_post,
  config_list_config_post,
  config_list_config_benefit_post,
  config_list_config_flow_days_post,
  config_list_config_flow_days_report_post,
  config_list_config_permissions_post,
  config_list_config_product_price_post,
  config_list_config_size_post,
  config_list_config_staff_match_post,
  config_list_config_supplier_info_post,
  config_list_config_warehouse_post,
  config_list_process_post,
  config_list_process_name_post,
  config_list_process_node_post,
  config_list_process_node_name_post,
  config_list_process_node_relation_post,
  config_list_process_node_state_post,
  config_list_product_category_post,
  config_list_staff_post,
  config_list_staff_all_post,
  config_list_supplier_cycle_post,
  config_qr_code_url_post,
  config_query_config_permissions_post,
  config_query_menu_button_post,
  config_submit_config_benefit_post,
  config_submit_config_supplier_info_post,
  config_submit_config_warehouse_post,
  config_submit_edit_add_supplier_post,
  config_supplier_edit_infos_post,
  config_update_config_flow_day_post,
  config_update_config_permissions_post,
  config_export_post,
  config_add_holiday_post,
  config_list_holiday_post,
  config_renew_process_name_post,
  config_renew_process_name_v2_post,
  config_list_column_post,
  config_list_config_automatic_number_post,
  config_add_config_automatic_number_post,
  config_delete_config_automatic_number_post,
  config_edit_config_automatic_number_post,
  config_get_process_node_url_post,
  config_upload_process_node_post,
  config_get_process_node_post,
  config_list_menu_field_post,
  config_update_menu_field_post,
  config_list_product_second_category_post,
  config_reset_password_post
} from 'server/modules/1890'

// 新增流程节点天数配置
export const config_add_config_flow_day_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_config_flow_day_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增工作台配置
export const config_add_config_permissions_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_config_permissions_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增产品品类对应价格占比配置
export const config_add_config_product_price_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_config_product_price_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 编辑二级品类尺码配置
export const config_add_config_product_size_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_config_product_size_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增设计师、版师、工艺员对应关系配置
export const config_add_config_staff_match_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_config_staff_match_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增流程配置
export const config_add_process_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_process_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增流程节点配置
export const config_add_process_node_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_process_node_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增流程节点关系
export const config_add_process_node_relation_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_add_process_node_relation_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增流程节点配置
export const config_add_process_node_state_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_process_node_state_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 提交供应商支付周期数据
export const config_add_supplier_cycle_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_supplier_cycle_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 删除流程节点天数配置
export const config_del_config_flow_day_post_ = async function(params) {
  const { success, data, retInfo } = await config_del_config_flow_day_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 删除工作台配置
export const config_del_config_permissions_post_ = async function(params) {
  const { success, data, retInfo } = await config_del_config_permissions_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 删除产品品类对应价格占比配置
export const config_del_config_product_price_post_ = async function(params) {
  const { success, data, retInfo } = await config_del_config_product_price_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增设计师、版师、工艺员对应关系配置
export const config_del_config_staff_match_post_ = async function(params) {
  const { success, data, retInfo } = await config_del_config_staff_match_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 删除供应商支付周期数据
export const config_del_supplier_cycle_get_ = async function(params) {
  const { success, data, retInfo } = await config_del_supplier_cycle_get(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 刪除流程节点配置
export const config_delete_process_node_post_ = async function(params) {
  const { success, data, retInfo } = await config_delete_process_node_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 刪除流程节点关系
export const config_delete_process_node_relation_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_delete_process_node_relation_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 刪除流程节点配置
export const config_delete_process_node_state_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_delete_process_node_state_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 根据sk查询cp
export const config_get_cp_by_skc_post_ = async function(params) {
  const { success, data, retInfo } = await config_get_cp_by_skc_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 导入价格品类
export const config_importSupplierInfo_post_ = async function(params) {
  const { success, data, retInfo } = await config_importSupplierInfo_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 初始化cp-skc
export const config_init_cp_skc_post_ = async function(params) {
  const { success, data, retInfo } = await config_init_cp_skc_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询服装配置码值列表
export const config_list_category_size_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_category_size_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 系统配置列表查询
export const config_list_config_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_config_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 利润率配置查询
export const config_list_config_benefit_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_config_benefit_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 流程节点天数配置查询
export const config_list_config_flow_days_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_config_flow_days_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 报表流程节点天数
export const config_list_config_flow_days_report_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_list_config_flow_days_report_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 工作台权限配置列表
export const config_list_config_permissions_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_config_permissions_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 产品品类对应价格占比配置表查询
export const config_list_config_product_price_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_list_config_product_price_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 系统配置列表查询
export const config_list_config_size_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_config_size_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 设计师、版师、工艺员对应关系配置查询
export const config_list_config_staff_match_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_config_staff_match_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 供应商主数据查询
export const config_list_config_supplier_info_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_list_config_supplier_info_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 供应商仓库映射配置查询
export const config_list_config_warehouse_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_config_warehouse_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询流程配置
export const config_list_process_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_process_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询流程节点信息
export const config_list_process_name_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_process_name_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询流程节点配置
export const config_list_process_node_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_process_node_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询流程配置名称
export const config_list_process_node_name_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_process_node_name_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询流程节点状态关系
export const config_list_process_node_relation_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_list_process_node_relation_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询流程节点状态配置
export const config_list_process_node_state_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_process_node_state_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询产品分类
export const config_list_product_category_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_product_category_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 员工查询信息
export const config_list_staff_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_staff_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 员工查询信息
export const config_list_staff_all_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_staff_all_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询供应商支付周期数据
export const config_list_supplier_cycle_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_supplier_cycle_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 二维码
export const config_qr_code_url_post_ = async function(params) {
  const { success, data, retInfo } = await config_qr_code_url_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询用户权限
export const config_query_config_permissions_post_ = async function(params) {
  const { success, data, retInfo } = await config_query_config_permissions_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询按钮
export const config_query_menu_button_post_ = async function(params) {
  const { success, data, retInfo } = await config_query_menu_button_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 提交利润率配置
export const config_submit_config_benefit_post_ = async function(params) {
  const { success, data, retInfo } = await config_submit_config_benefit_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 提交易仓供应商配置表
export const config_submit_config_supplier_info_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_submit_config_supplier_info_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 提交供应商仓库映射配置
export const config_submit_config_warehouse_post_ = async function(params) {
  const { success, data, retInfo } = await config_submit_config_warehouse_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 提交编辑新增供应商
export const config_submit_edit_add_supplier_post_ = async function(params) {
  const { success, data, retInfo } = await config_submit_edit_add_supplier_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 供应商编辑页面
export const config_supplier_edit_infos_post_ = async function(params) {
  const { success, data, retInfo } = await config_supplier_edit_infos_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 更新流程节点天数配置
export const config_update_config_flow_day_post_ = async function(params) {
  const { success, data, retInfo } = await config_update_config_flow_day_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 更新工作台配置
export const config_update_config_permissions_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_update_config_permissions_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 供应商列表导出
export const config_export_post_ = async function(params) {
  const { success, data, retInfo } = await config_export_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增节假日配置
export const config_add_holiday_post_ = async function(params) {
  const { success, data, retInfo } = await config_add_holiday_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 节假日查询
export const config_list_holiday_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_holiday_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// renew流程节点信息
export const config_renew_process_name_post_ = async function(params) {
  const { success, data, retInfo } = await config_renew_process_name_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// renew流程节点信息V2
export const config_renew_process_name_v2_post_ = async function(params) {
  const { success, data, retInfo } = await config_renew_process_name_v2_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 获取动态列值
export const config_list_column_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_column_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// cp自动取号配置查询
export const config_list_config_automatic_number_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_list_config_automatic_number_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 新增cp自动取号配置
export const config_add_config_automatic_number_post_ = async function(params) {
  const {
    success,
    data,
    retInfo
  } = await config_add_config_automatic_number_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 删除cp自动取号配置
export const config_delete_config_automatic_number_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_delete_config_automatic_number_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 编辑cp自动取号配置
export const config_edit_config_automatic_number_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_edit_config_automatic_number_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 流程节点模板下载url
export const config_get_process_node_url_post_ = async function(params) {
  const { success, data, retInfo } = await config_get_process_node_url_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 上传流程节点明细
export const config_upload_process_node_post_ = async function(params) {
  const { success, data, retInfo } = await config_upload_process_node_post(
    params
  )
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 获取流程节点明细
export const config_get_process_node_post_ = async function(params) {
  const { success, data, retInfo } = await config_get_process_node_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 获取动态菜单列
export const config_list_menu_field_post_ = async function(params) {
  const { success, data, retInfo } = await config_list_menu_field_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 更新动态菜单列
export const config_update_menu_field_post_ = async function(params, callback) {
  const { success, data, retInfo } = await config_update_menu_field_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
    callback && callback()
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 查询产品分类(精确到二级类目)
export const config_list_product_second_category_post_ = async function(
  params
) {
  const {
    success,
    data,
    retInfo
  } = await config_list_product_second_category_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}

// 重置密码
export const config_reset_password_post_ = async function(params) {
  const { success, data, retInfo } = await config_reset_password_post(params)
  if (success) {
    console.log(data)
    message.success(retInfo)
  } else {
    console.log(data)
    message.error(retInfo)
  }
}
